import lazyWithRetry from "./lazyWithRetry";
import optimizeHtml from "./optimizeHtml";
import routeElement from "./routeElement";
import windowControlsOverlay from "./windowControlsOverlay";

const OptimizationUtils = {
  lazyWithRetry,
  optimizeHtml,
  routeElement,
  windowControlsOverlay,
};

export default OptimizationUtils;
